import { useContext } from 'react';
import { Context } from '../components/Provider';

const useShellEnv = () => useContext(Context);

export default useShellEnv;
